const DPrxiesPrice = [
  {
    id: 1,
    name: '5',
    price: 6.5,
  },
  {
    id: 2,
    name: '10',
    price: 13,
  },
  {
    id: 3,
    name: '25',
    price: 32.50,
  },
  {
    id: 4,
    name: '50',
    price: 62.50,
  },
  {
    id: 5,
    name: '75',
    price: 93.75,
  },
  {
    id: 6,
    name: '100',
    price: 120,
  },
  {
    id: 7,
    name: '125',
    price: 150,
  },
  {
    id: 8,
    name: '150',
    price: 180,
  },
  {
    id: 9,
    name: '200',
    price: 240,
  },
];

export default DPrxiesPrice;
